export const TABLE_HEAD = [
  { id: "record", label: "Record", alignRight: false },
  { id: "fpts", label: "Fpts", alignRight: false },
  { id: "score", label: "Score", alignRight: false },
  { id: "opponentFpts", label: "Vs Fpts", alignRight: false },
  { id: "opponent", label: "Opponent", alignRight: false },
  { id: "mode", label: "Mode", alignRight: false },
  { id: "entry", label: "Entry", alignRight: false },
  { id: "prize", label: "Prize", alignRight: false },
  { id: "won", label: "Won", alignRight: false },
  { id: "date", label: "Date", alignRight: false },
  { id: "details", label: "Details", alignRight: false },
];
